import SmallTxNotification from './SmallTxNotification'

export default SmallTxNotification


// WEBPACK FOOTER //
// ./src/components/SmallTxNotification/index.js